import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useThemeSlice } from 'styles/theme/slice';
import { selectSidebarCollapsed } from 'styles/theme/slice/selectors';

type Props = {};

const ToggleSidebarButton: React.FC<Props> = () => {
  const isCollapsed = useSelector(selectSidebarCollapsed);
  const themeActions = useThemeSlice().actions;
  const dispatch = useDispatch();

  return (
    <Button
      icon={isCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      onClick={() => dispatch(themeActions.toggleSidebar())}
      shape="circle"
      type="text"
      size="large"
      className="header-sidebar-toggle-button"
    />
  );
};

export default ToggleSidebarButton;
